import _ from 'ckLodash';

function isNestedList(elem) {
    if (!/ol|ul/i.test(elem.tagName)) {
        return false;
    }
    let node = elem.parentElement;
    while (node) {
        if (!/ol|ul/i.test(node.tagName)) {
            return true;
        }
        node = node.parentElement;
    }
    return false;
}

function areTextBlocksValid(frag) {
    const blockElements = frag.querySelectorAll('p, h1, h2, h3, h4, h5, h6, blockquote, ol, ul');
    return _.every(blockElements, elem => /\bfont_\d+\b/.test(elem.className) || isNestedList(elem));
}

function areColorStylesValid(frag) {
    const colorSpans = frag.querySelectorAll('span[style*="color"]');
    return _.every(colorSpans, elem => /color:\s*(?:#[A-Fa-f0-9]{6}|#[A-Fa-f0-9]{3}|rgb\s*\(\s*\d+\s*,\s*\d+\s*,\s*\d+\s*\))/.test(elem.style.cssText));
}

function areSpansValid(frag) {
    const spans = frag.querySelectorAll('span');
    return _.every(spans, element => {
        const cssText = element.style.cssText;
        const className = element.className;
        if (cssText && className) {
            return false;
        }
        if (cssText) {
            if (/(.+:.+){2,}/.test(cssText)) {
                //more than one style in span, disallowed
                return false;
            }
            //element has style, does not have class, need to see that style is one that we support
            return true;
        }
        if (className) {
            return true;
        }
        //useless span, no style and no class:.Not valid
        return false;
    });
}

function isValidHtml(htmlStr) {
    const div = document.createElement('div');
    div.innerHTML = htmlStr;
    return areTextBlocksValid(div) && areColorStylesValid(div) && areSpansValid(div);
}

export default isValidHtml;
